import styles from './FJImageManipulationRight.module.less';
import PropTypes from 'prop-types';
import FJDragBox from '../../../../common/components/FJDragBox/FJDragBox.jsx';
import FJDisplayHeaderContainer from '../../../FJMainPreview/FJDisplayHeader/FJDisplayHeaderContainer.jsx';
import FJHistoryPanelContainer from '../../../FJMainPreview/FJHistoryPanel/FJHistoryPanelContainer.jsx';
import FJCreationEditPanelContainer from '../../../FJMainPreview/FJCreationEditPanel/container/FJCreationEditPanelContainer.jsx';
import classNames from 'classnames';
import FJUtil from '../../../../util/FJUtil.js';
import FJLocalStore from '../../../../store/FJLocalStore.js';
import FJConstant from '../../../../constants/FJConstant.js';
import FJButton, { FJButtonType } from '../../../../common/components/FJButton/FJButton.jsx';
import DownloadIcon from '../../../../assets/svg/download_black.svg?react';
import FJImageToVideoButtonContainer from '../../../../common/combineComponents/FJImageToVideoButtonContainer/container/FJImageToVideoButtonContainer.jsx';

const FJImageManipulationRight = props => {
    const {
        uploadImg,
        setIsDraggingFile,
        headerTabIndex,
        taskStatus,
        download,
        isCanDownload,
        hasEditImage,
        downloadEditImageLoading,
    } = props;

    const renderDownload = () => {
        if (
            FJUtil.isGeneratingStatus(taskStatus) ||
            taskStatus === FJConstant.ERROR ||
            headerTabIndex !== FJConstant.CREATIONS ||
            !isCanDownload
        ) {
            return null;
        }

        if (window.isEditPage) return null;

        return (
            <div className={styles.download_box}>
                <FJImageToVideoButtonContainer isOnlyBtn={true} />
                <FJButton
                    onClick={download}
                    className={classNames(styles.download, downloadEditImageLoading && styles.loading)}
                    textClassName={styles.download_text}
                    text={FJLocalStore._('download')}
                    isLoading={downloadEditImageLoading}
                    type={FJButtonType.GRADIENT}
                    icon={<DownloadIcon className={styles.download_icon} />}
                />
            </div>
        );
    };

    return (
        <FJDragBox
            setIsDragging={setIsDraggingFile}
            uploadFile={uploadImg}
            disable={FJUtil.isGeneratingStatus(taskStatus)}
            className={classNames(styles.app_right)}
        >
            <FJDisplayHeaderContainer
                rightChildren={renderDownload()}
                hasEditImage={hasEditImage}
                hideCancelButton={true}
            />

            <FJCreationEditPanelContainer activeHeaderTabIndex={FJConstant.CREATIONS} />

            <FJHistoryPanelContainer activeHeaderTabIndex={FJConstant.HISTORY} />
        </FJDragBox>
    );
};
FJImageManipulationRight.propTypes = {
    uploadImg: PropTypes.func,
    setIsDraggingFile: PropTypes.func,
    headerTabIndex: PropTypes.string,
    taskStatus: PropTypes.string,
    creationList: PropTypes.array,
    download: PropTypes.func,
    downloadEditImageLoading: PropTypes.bool,
    isCanDownload: PropTypes.bool,
    hasEditImage: PropTypes.bool,
};
export default FJImageManipulationRight;
